import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Route } from '../core/route.service';
import { extract } from '../core/i18n.service';
import { MultiDestinationComponent } from './multi-destination.component';

const routes: Routes =[
  { path: 'multi-destination', component: MultiDestinationComponent, data: { title: extract('Multidestination') } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class MultiDestinationRoutingModule { }
